module.exports = __webpack_public_path__ + "img/bgbottom2x.f409e7c2.png";